<template>
  <HelpPage />
</template>

<script setup lang="ts">
import HelpPage from "shared-ui/pages/HelpPage.vue";

definePage({
  meta: {
    requiresAuth: false,
    layout: "AppLayout",
  },
});
</script>
